import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApiUrlPipe } from 'src/lib/pipes/api-url.pipe';
import { CanPipe } from 'src/lib/pipes/can.pipe';
import { FiltersPipe } from 'src/lib/pipes/filters.pipe';
import { LinkifyPipe } from '@lib/pipes/linkify.pipe';
import { PhoneNumberPipe } from 'src/lib/pipes/phone-number.pipe';
import { SPipe } from 'src/lib/pipes/s.pipe';
import { OnClickOutsideDirective } from 'src/lib/directives/click-outside.directive';
import { InfiniteScrollDirective } from 'src/lib/directives/infinite-scroll.directive';
import { SmoothHeightDirective } from 'src/lib/directives/smooth-height.directive';
import { CopyToClipboardDirective } from 'src/lib/directives/copy-to-clipboard.directive';
import { MatBadgeIconDirective } from 'src/lib/directives/mat-badge-icon.directive';
import { MatBadgeColorizeDirective } from './directives/mat-badge-colorize.directive';
import { MatFormFieldWaitingDirective } from './directives/mat-form-field-waiting.directive';
import { MatFileInputTriggerForDirective } from './directives/mat-file-input-trigger-for.directive';
import { MatTooltipCtaDirective } from './directives/mat-tooltip-cta.directive';
import { StickyDirective } from './directives/sticky.directive';

@NgModule({
  	declarations: [
		ApiUrlPipe,
		CanPipe,
		FiltersPipe,
		LinkifyPipe,
		PhoneNumberPipe,
		SPipe,
		OnClickOutsideDirective,
		InfiniteScrollDirective,
		SmoothHeightDirective,
		CopyToClipboardDirective,
		MatBadgeIconDirective,
		MatBadgeColorizeDirective,
		MatFormFieldWaitingDirective,
  		MatFileInputTriggerForDirective,
        MatTooltipCtaDirective,
        StickyDirective
	],
	imports: [
		CommonModule
	],
	exports: [
		ApiUrlPipe,
		CanPipe,
		FiltersPipe,
		LinkifyPipe,
		PhoneNumberPipe,
		SPipe,
		OnClickOutsideDirective,
		InfiniteScrollDirective,
		SmoothHeightDirective,
		CopyToClipboardDirective,
		MatBadgeIconDirective,
		MatBadgeColorizeDirective,
		MatFormFieldWaitingDirective,
		MatFileInputTriggerForDirective,
        MatTooltipCtaDirective,
        StickyDirective
	]
})
export class SharedModule { }
